import {
  CONFIGURED_FORM_ENABLED,
  MINT_ON_VIEW_ENABLED,
  IS_ALE_ENABLED,
  IS_PORTAL_ENABLED,
  AUTOSHIP_DEACTIVATED_PETS_ENABLED,
} from '../util/config';
import { generateLoadDataFn, getFeatureConfigEndpoint } from '../util/useFeature';

// Feature Flag 'configDrivenForm.enabled'
const configuredFormFeatureRequestRoute = getFeatureConfigEndpoint(CONFIGURED_FORM_ENABLED);
const featureConfiguredFormArrowFunction = generateLoadDataFn(configuredFormFeatureRequestRoute);
export const featureConfiguredFormLoadData = async function () {
  return await featureConfiguredFormArrowFunction();
};
featureConfiguredFormLoadData.key = `FEATURE/${CONFIGURED_FORM_ENABLED}`;
featureConfiguredFormLoadData.requiresPetId = false;

// Feature Flag 'mintOnView.enabled'
const mintOnViewRequestRoute = getFeatureConfigEndpoint(MINT_ON_VIEW_ENABLED);
const featureMintOnViewArrowFunction = generateLoadDataFn(mintOnViewRequestRoute);
export const featureMintOnViewLoadData = async function () {
  return await featureMintOnViewArrowFunction();
};
featureMintOnViewLoadData.key = `FEATURE/${MINT_ON_VIEW_ENABLED}`;
featureMintOnViewLoadData.requiresPetId = false;

// Feature Flag ALE
const isAleEnabledRoute = getFeatureConfigEndpoint(IS_ALE_ENABLED);
const isAleEnabledArrowFunction = generateLoadDataFn(isAleEnabledRoute);
export const isAleEnabledFormLoadData = async function () {
  return await isAleEnabledArrowFunction();
};
isAleEnabledFormLoadData.key = `FEATURE/${IS_ALE_ENABLED}`;
isAleEnabledFormLoadData.requiresPetId = false;

// Feature Flag
export const isPortalEnabledRoute = getFeatureConfigEndpoint(IS_PORTAL_ENABLED);
const isPortalEnabledArrowFunction = generateLoadDataFn(isPortalEnabledRoute);
export const isPortalEnabledFormLoadData = async function () {
  const res = await isPortalEnabledArrowFunction();
  return res;
};
isPortalEnabledFormLoadData.key = `FEATURE/${IS_PORTAL_ENABLED}`;
isPortalEnabledFormLoadData.requiresPetId = false;
// Feature Flag autoship.deactivatedPets.enabled
const autoshipDeactivatedPetsEnabledRoute = getFeatureConfigEndpoint(
  AUTOSHIP_DEACTIVATED_PETS_ENABLED,
);
const autoshipDeactivatedPetsEnabledArrowFunction = generateLoadDataFn(
  autoshipDeactivatedPetsEnabledRoute,
);
export const autoshipDeactivatedPetsEnabledLoadData = async function () {
  return await autoshipDeactivatedPetsEnabledArrowFunction();
};
autoshipDeactivatedPetsEnabledLoadData.key = `FEATURE/${AUTOSHIP_DEACTIVATED_PETS_ENABLED}`;
autoshipDeactivatedPetsEnabledLoadData.requiresPetId = false;
